"use client";

import { useEffect } from "react";

/**
 * Voegt muispositie-tracking toe aan .button elementen voor het
 * radial-gradient hover-effect (CSS variabelen --mx en --my).
 * Werkt alleen op desktop (hover-capabele devices).
 */
export function ButtonMouseTracking() {
  useEffect(() => {
    if (!window.matchMedia("(hover: hover)").matches) return;

    const onMouseMove = (e: MouseEvent) => {
      const target = e.target;
      if (!(target instanceof HTMLElement)) return;
      const button = target.closest<HTMLElement>(".button");
      if (!button) return;

      const rect = button.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      button.style.setProperty("--mx", `${x}%`);
      button.style.setProperty("--my", `${y}%`);
    };

    const onMouseLeave = (e: MouseEvent) => {
      const target = e.target;
      if (!(target instanceof HTMLElement)) return;
      const button = target.closest<HTMLElement>(".button");
      if (!button) return;
      button.style.removeProperty("--mx");
      button.style.removeProperty("--my");
    };

    document.addEventListener("mousemove", onMouseMove, { passive: true });
    document.addEventListener("mouseleave", onMouseLeave, { passive: true });

    return () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseleave", onMouseLeave);
    };
  }, []);

  return null;
}